import { ReactNode } from "react";
import { CircleWord } from "@/components/ScribbleAccents";

/**
 * Hand-drawn scribble circle for dark backgrounds (hero quiz link).
 * Now animated: the circle draws itself on when scrolled into view.
 */
export function CircleScribble({ children }: { children: ReactNode }) {
  return (
    <CircleWord color="#ffffff" delay={0.5}>
      <span className="inline-block py-[6px]">{children}</span>
    </CircleWord>
  );
}
